import React from "react";
import { twMerge } from "tailwind-merge";
import { ContentBlockNewsletterDefaultType } from "../../../types/blocks";

const BlockNewsletterDefault = ({
  headline,
  copytext,
  block_settings: { background_color, html_id } = {
    background_color: "bg-white dark:bg-secondary-900",
  },
}: Omit<ContentBlockNewsletterDefaultType, "type">) => {
  return (
    <section className={twMerge(background_color, "scroll-mt-20")} id={html_id}>
      <div className="max-w-screen-xl px-4 py-8 mx-auto sm:py-16 lg:px-6 ">
        <div className="max-w-screen-md mx-auto text-center">
          <h2 className="mb-4 text-4xl font-extrabold tracking-tight text-secondary-900 dark:text-white">
            {headline}
          </h2>
          <p className="mb-6 font-normal text-secondary-500 md:text-lg dark:text-secondary-400">
            {copytext}
          </p>
          <form action="#" className="max-w-screen-sm mx-auto">
            <div className="flex items-center mb-3">
              <div className="relative w-full mr-3">
                <label
                  htmlFor="member_email"
                  className="hidden mb-2 text-sm font-medium text-secondary-900 dark:text-secondary-300"
                >
                  Email address
                </label>
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <svg
                    className="w-5 h-5 text-secondary-500 dark:text-secondary-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
                  </svg>
                </div>
                <input
                  className="block w-full p-3 pl-10 text-sm border border-gray-300 rounded-lg text-secondary-900 bg-secondary-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-secondary-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  placeholder="Enter your email"
                  type="email"
                  name="member[email]"
                  id="member_email"
                  required
                />
              </div>
              <div>
                <input
                  type="submit"
                  value="Subscribe"
                  className="px-5 py-3 text-sm font-medium text-center text-white rounded-lg cursor-pointer bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                  name="member_submit"
                  id="member_submit"
                />
              </div>
            </div>
            <div className="text-sm font-medium text-left text-secondary-500 dark:text-secondary-300">
              Instant signup. No credit card required.{" "}
              <a
                href="#"
                className="text-primary-600 hover:underline dark:text-primary-500"
              >
                Terms of Service
              </a>{" "}
              and{" "}
              <a
                className="text-primary-600 hover:underline dark:text-primary-500"
                href="#"
              >
                Privacy Policy
              </a>
              .
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default BlockNewsletterDefault;
